import React from 'react';
import {Formik} from "formik";
import {NewPasswordFormFields} from "../../models/forms.model";
import {newPasswordSchema} from "../../validationSchemas/newPasswordSchema";
import {PasswordField} from "../FormFields/PasswordField";

interface HandleSubmission {
    handleFormSubmission: (values:NewPasswordFormFields,{setSubmitting}) => void
}

const NewPasswordForm=(props: HandleSubmission) => {
    const initialFormState: NewPasswordFormFields = {
        password: "",
        confirm_password: "",
    };

    return(
        <>
            <h1 className="font-Cls h-48 f-s32 f-sm-s22 text-md-center mb-4">
                New Password
            </h1>
            <Formik
                initialValues={initialFormState}
                validationSchema={newPasswordSchema}
                onSubmit={props.handleFormSubmission}
            >
                {({
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                      isSubmitting,
                      submitForm,
                  }) => (
                    <form onSubmit={handleSubmit}>
                        <PasswordField
                            name={"password"}
                            labelText={"Password"}
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                        />
                        <PasswordField
                            name={"confirm_password"}
                            labelText={"Confirm Password"}
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                        />
                        <hr className="my-4 d-md-none" />
                        <div className="max-content m-auto pt-4">
                            <button
                                type="submit"
                                onClick={ (event: any) => {
                                    event.preventDefault()
                                    submitForm()
                                }}
                                disabled={isSubmitting}
                                className="btn btn-large d-block"
                            >
                                Confirm New Password
                            </button>
                        </div>
                    </form>
                )}
            </Formik>
        </>
    )
}
export default NewPasswordForm;